import { UmbControllerBase } from '@umbraco-cms/backoffice/class-api';

export abstract class UmbRepositoryBase extends UmbControllerBase {}
